import { createFileRoute } from "@tanstack/react-router";
import { FuncionalidadesHubPage } from "@/components/pages/FuncionalidadesHubPage";
import { FEATURE_MODULES } from "@/lib/features-data";
import { breadcrumbLd, ldScripts, webPageLd } from "@/lib/seo-jsonld";

const SITE = "https://kentro.com.br";
const URL = `${SITE}/funcionalidades`;
const TITLE = "Funcionalidades — Kentro Sistemas";
const DESC =
  "Base completa das funcionalidades da plataforma Kentro: operação de atendimento, CRM e funis de vendas, relatórios e configurações administrativas.";

export const Route = createFileRoute("/funcionalidades/")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:locale", content: "pt_BR" },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "alternate", hrefLang: "pt-BR", href: URL },
      { rel: "alternate", hrefLang: "x-default", href: URL },
    ],
    scripts: ldScripts(
      breadcrumbLd([
        { name: "Início", path: "/" },
        { name: "Funcionalidades", path: "/funcionalidades" },
      ]),
      webPageLd({ url: URL, name: TITLE, description: DESC }),
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement: FEATURE_MODULES.map((m, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: m.title,
          item: `${SITE}/funcionalidades/${m.slug}`,
        })),
      },
    ),
  }),
  component: FuncionalidadesHubPage,
});
